import { useState } from "react";
import { connect } from "react-redux";
import { useNavigate } from "react-router-dom";
import toast from "react-hot-toast";
import moment from "moment";
import ReactPixel from 'react-facebook-pixel';

import CustomButton from "../../../common/CustomButton";

import { LoadLatestSurveyScores, GetSurveyQuestions, } from "../../../redux/v2/user/actions";

function Intro(props) {
    const navigate = useNavigate();

    const { next, redo, redoType } = props;
    const { account } = props.User;
    const [clicked, setClicked] = useState(false);

    return (
        <div id="gs-v2-intro">
            {
                !redo && <>
                    <h4>WELCOME TO INDI</h4>
                    <div>
                        <p>
                            To help you get moving, we would love to learn more about you.<br /><br />
                            Take a few minutes and complete your profile. The information provided will help us create the best experience for you.
                        </p>
                    </div>
                    <div className="mt-5">
                        <CustomButton onClick={async () => {
                            if (!clicked) {
                                if (props?.bypass) {
                                    const res = await props.LoadLatestSurveyScores();
                                }

                                setClicked(true);
                                next();
                                ReactPixel.trackCustom('StartTrial', {
                                    value: 70.00,
                                    currency: "USD"
                                });
                            }
                        }}>
                            GET STARTED
                        </CustomButton>
                    </div>
                </>
            }

            {
                redo && <>
                    <h4>WELCOME BACK, {account?.user?.first_name?.toUpperCase()}</h4>
                    <div className="description-part">
                        <body>
                            {
                                redoType == "half"
                                    ? "Please answer three questions as it relates to your progress. Doing so will allow us to provide you with new exercises & programs to keep you moving"
                                    : "It's time for a health check-in! Please take a minute to update your program!"
                            }
                        </body>
                    </div>
                    <div className="button-part my-30 row">
                        <div className="col-md-6 mb-2 flex-c">
                            <CustomButton style={{ minWidth: "180px" }} onClick={async () => {
                                if (!clicked) {
                                    setClicked(true);
                                    const toastId = toast.loading("Loading previous scores...");
                                    const res = await props.LoadLatestSurveyScores();
                                    const res2 = await props.GetSurveyQuestions(JSON.parse(localStorage.getItem("goal_ids")));

                                    if (res) {
                                        toast.success('Scores loaded.', {
                                            id: toastId,
                                        });
                                    } else {
                                        toast.error('Failed to load scores.', {
                                            id: toastId,
                                        });
                                    }

                                    props.next();
                                }

                            }}>
                                START
                            </CustomButton>
                        </div>
                        <div className="col-md-6 mt-3 mb-2 flex-c">
                            <p style={{ color: "#b2b2b2", cursor: "pointer" }} onClick={() => {
                                localStorage.setItem("indi-skip-survey", true);

                                let repeatDate = moment(new Date());
                                repeatDate.add(5, "days");

                                localStorage.setItem("indi-skip-survey-repeat-date", repeatDate.format());

                                navigate(process.env.PUBLIC_URL + "/home");
                            }}>Skip</p>
                        </div>

                    </div>
                </>
            }
        </div >
    );
}

const mapStateToProps = (state) => ({
    User: state.User,
});

export default connect(mapStateToProps, {
    LoadLatestSurveyScores,
    GetSurveyQuestions,
})(Intro);